<template>
    <div class="loading-container" v-show="loading">
        <div class="v-spinner">
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        props: {
            loading: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style scoped>

</style>
